<template>
  <!-- Rendered on the server with the page, so the credit is painted at first paint instead of when the map has
       loaded (MapLibre's own control was a late, large LCP candidate on phones). Open until the map is first moved,
       like MapLibre's compact control; the (i) button reopens it. It stops short of the zoom buttons (top right). -->
  <details
    :open="open"
    @toggle="$emit('update:open', $event.target.open)"
    :class="open ? 'pl-7 pr-2 py-0.5' : ''"
    absolute
    top-0
    left-0
    z-2
    m-2.5
    max-w="[calc(100%-3.75rem)]"
    min-h-6
    min-w-6
    rounded-3
    bg-white
    text="xs black"
    leading-5
    font="[Helvetica_Neue,Arial,Helvetica,sans-serif]"
  >
    <summary
      aria-label="Map data sources"
      title="Map data sources"
      class="[&::-webkit-details-marker]:hidden"
      :class="open ? 'bg-black/5' : 'bg-white/50'"
      absolute
      top-0
      left-0
      size-6
      cursor-pointer
      list-none
      rounded-3
    >
      <svg viewBox="0 0 20 20" size-6 aria-hidden="true">
        <path
          fill-rule="evenodd"
          d="M4 10a6 6 0 1 0 12 0 6 6 0 1 0-12 0m5-3a1 1 0 1 0 2 0 1 1 0 1 0-2 0m0 3a1 1 0 1 1 2 0v3a1 1 0 1 1-2 0"
        />
      </svg>
    </summary>
    <template v-for="(credit, i) in MAP_ATTRIBUTION" :key="i">
      <template v-if="i > 0">{{ " | " }}</template>
      <template v-for="(part, j) in credit" :key="j">
        <template v-if="j > 0">{{ " " }}</template>
        <a v-if="part.href" :href="part.href" target="_blank" rel="noopener" class="text-black/75 hover:(text-black underline)">{{
          part.text
        }}</a>
        <template v-else>{{ part.text }}</template>
      </template>
    </template>
  </details>
</template>
<script setup>
defineProps({
  open: {
    type: Boolean,
    default: true,
  },
});
defineEmits(["update:open"]);
</script>
<script>
// The credits for every map's data. All styles in public/styles/ use OpenFreeMap's OpenMapTiles vector tiles
// (this is their TileJSON's attribution) and Mapterhorn elevation for the hillshade and contour lines; Natural Earth
// (elevation-color) is public domain. test/unit/map-attribution.test.ts checks this against the styles.
export const MAP_ATTRIBUTION = [
  [{ text: "© Mapterhorn", href: "https://mapterhorn.com/attribution" }],
  [
    { text: "OpenFreeMap", href: "https://openfreemap.org" },
    { text: "© OpenMapTiles", href: "https://www.openmaptiles.org/" },
    { text: "Data from" },
    { text: "OpenStreetMap", href: "https://www.openstreetmap.org/copyright" },
  ],
];
</script>
